<template>
  <el-form ref="form">
    <el-row>
      <el-col :span="6" class="filter-input">
        <el-input
          :placeholder="$t('keyword')"
          @input="isSearching = true"
          v-model="keyword"></el-input>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="24" v-loading="isSearching">
        <div class="contract-table contract-table-head">
          <ul>
            <li style="width: 5%"></li>
            <li style="width: 35%">{{$t('name')}}</li>
            <li style="width: 60%">{{$t('detail')}}</li>
          </ul>
        </div>
        <div v-for="(termsOfPayment, index) of termsOfPaymentTableDataList" :key="`termsOfPayment-${index}`">
          <div class="contract-table" v-show="termsOfPayment.isShow">
            <ul>
              <li style="width: 5%; text-align: center"><el-checkbox v-model="termsOfPaymentCheckList[index].isCheck" @change="onSelectedTermsOfPaymentChange"></el-checkbox></li>
              <li style="width: 35%">{{termsOfPayment.name}}</li>
              <li style="width: 60%; white-space: pre-line;">{{termsOfPayment.detail}}</li>
            </ul>
            <div class="contract-data-version" v-if="isUpdatedData(termsOfPaymentList, termsOfPayment)">
              <div class="contract-data-updated">
                <div style="padding: 20px 0 0 20px">
                  <strong>*{{$t('updatedTermsOfPaymentMessage')}}</strong>
                </div>
                <el-radio-group style="padding-left: 40px" v-model="termsOfPaymentCheckList[index].version" fill="#ff0000" @change="onSelectedTermsOfPaymentChange()">
                  <div class="contract-data-version-radio">
                    <el-radio :label="DATA_VERSION.SELECTED">{{$t('selectedVersion')}} ({{bindUpdatedAt(termsOfPayment.updatedAt)}})</el-radio>
                  </div>
                  <div class="contract-data-version-radio">
                    <el-radio :label="DATA_VERSION.LATEST">{{$t('latestVersion')}} ({{bindLatestUpdatedAt(termsOfPayment.id)}})</el-radio>
                  </div>
                </el-radio-group>
              </div>
            </div>
            <div class="contract-data-version" v-if="isDeletedData(termsOfPaymentList, termsOfPayment.id)">
              <div class="contract-data-deleted">
                <div style="padding: 20px 0 0 20px">
                  <strong style="color: #dd3333">*{{$t('deletedTermsOfPaymentMessage')}}</strong>
                </div>
                <el-radio-group style="padding-left: 40px" v-model="termsOfPayment.id" fill="#ff0000" >
                  <el-radio :label="termsOfPayment.id" class="contract-data-version-radio">{{$t('selectedVersion')}} ({{bindUpdatedAt(termsOfPayment.updatedAt)}})</el-radio>
                </el-radio-group>
              </div>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
  </el-form>
</template>

<script>
import i18nMessages from '@/translations/Contract/components/TabTermsOfPayment.i18n'
import { filterDataByKeyword } from '@/services/general-service'
import { getTableDataSource } from '@/services/contract-service'
import { get, debounce } from 'lodash'
import { dateFormat } from '@/helpers/datetime'
import {
  isUpdatedData,
  isDeletedData,
  DATA_VERSION,
  getSelectedDataListByVersion,
  getDataCheckList
} from '@/services/version-service'
import { dynamicSort } from '@/helpers'

export default {
  name: 'TabTermsOfPaymentComponent',
  i18n: { messages: i18nMessages },
  model: {
    prop: 'contractDetail',
    event: 'onTermsOfPaymentDetailChange'
  },
  props: {
    termsOfPaymentList: {
      type: Array,
      default: function () {
        return []
      }
    },
    contractDetail: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  watch: {
    keyword: debounce(function () {
      this.isSearching = false
    }, 300),
    isSearching: function (value) {
      if (!value) {
        this._filterTermsOfPaymentListDataSource()
      }
    }
  },
  data () {
    return {
      DATA_VERSION,
      isUpdatedData,
      isDeletedData,
      termsOfPaymentTableDataList: [],
      termsOfPaymentCheckList: [],
      keyword: '',
      isSearching: false
    }
  },
  created: function () {
    this._getTermsOfPaymentListDataSource()

    const termsOfPaymentList = get(this.contractDetail, 'termsOfPaymentList', [])
    this.termsOfPaymentCheckList = getDataCheckList(this.termsOfPaymentTableDataList, termsOfPaymentList)
  },
  methods: {
    bindPeriodOfStay: function (startDate, endDate) {
      const fromDate = new Date(startDate)
      const toDate = new Date(endDate)

      return `${dateFormat.short(fromDate)} - ${dateFormat.short(toDate)}`
    },
    bindLatestUpdatedAt: function (contractTermsOfPaymentId) {
      const termsOfPayment = this.termsOfPaymentList.find(item => item.id === contractTermsOfPaymentId)

      if (termsOfPayment !== undefined) {
        const date = new Date(termsOfPayment.updatedAt)
        return dateFormat.long(date)
      }
    },
    bindUpdatedAt: function (updatedDate) {
      const date = new Date(updatedDate)
      return dateFormat.long(date)
    },
    onSelectedTermsOfPaymentChange () {
      const result = getSelectedDataListByVersion(
        this.termsOfPaymentCheckList,
        this.termsOfPaymentTableDataList,
        this.termsOfPaymentList
      )
      const termsOfPaymentList = {
        termsOfPaymentList: result
      }

      const contractDetail = Object.assign({}, this.contractDetail, termsOfPaymentList)
      this.$emit('onTermsOfPaymentDetailChange', contractDetail)
    },
    _getTermsOfPaymentListDataSource: function () {
      const termsOfPaymentList = get(this.contractDetail, 'termsOfPaymentList', [])
      this.termsOfPaymentTableDataList = getTableDataSource(this.termsOfPaymentList, termsOfPaymentList)

      this._prepareFilter()
    },
    _prepareFilter: function () {
      this.termsOfPaymentTableDataList = this.termsOfPaymentTableDataList.map((termsOfPayment) => {
        termsOfPayment.isShow = true
        return termsOfPayment
      })
      this.termsOfPaymentTableDataList.sort(dynamicSort('name'))
    },
    _filterTermsOfPaymentListDataSource: function () {
      const searchKeys = ['name', 'detail']
      const filteredTermsOfPaymentDataList = filterDataByKeyword(this.termsOfPaymentTableDataList, this.keyword, searchKeys)

      this.termsOfPaymentTableDataList = this.termsOfPaymentTableDataList.map((termsOfPayment) => {
        const filteredTermsOfPayment = filteredTermsOfPaymentDataList.find(item => item.id === termsOfPayment.id)
        termsOfPayment.isShow = (filteredTermsOfPayment !== undefined)

        return termsOfPayment
      })
      console.log('aaaaaaa')
    }
  }
}
</script>

<style scoped>
  .filter-input {
    left: 5%;
    position: relative;
    padding: 10px 0;
  }
</style>
